import { rgba } from "polished";
import styled from "styled-components";
import { ImageStyled } from "../../../../../../base/multimedia/image/styled.js";
import Skeleton from "../../../../../../structures/others/skeleton/index.js";
import { BoxShadow } from "../../../../../../../styles/common/mixins/box-shadow.styled.js";
import { FlexMixin, FontMixin } from "../../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../../../../styles/common/mixins/logical.styled.js";
export const BannerWrapper = styled.div.withConfig({
    displayName: "styled__BannerWrapper",
    componentId: "sc-6e364f97-0"
})`
	${FlexMixin({
    justify: 'space-between'
})}
	border-radius: ${BorderRadius({
    all: '4px'
})};
	width: 100%;
	${({ $isFlat  })=>!$isFlat ? `padding: 16px;` : 'padding: 16px 0;'}
`;
export const BannerContainer = styled.div.withConfig({
    displayName: "styled__BannerContainer",
    componentId: "sc-6e364f97-1"
})`
	${BoxShadow}
	overflow: hidden;
	position: relative;
	transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 0.1);
	width: 100%;

	& ${ImageStyled} > img {
		min-width: 100%;
	}
`;
export const BannerMask = styled.div.withConfig({
    displayName: "styled__BannerMask",
    componentId: "sc-6e364f97-2"
})`
	${FlexMixin({
    direction: 'column',
    justify: 'space-around'
})}
	height: 100%;
	padding: 24px 28px;
	position: absolute;
	right: 0;
	text-align: center;
	top: 0;

	&:before {
		background-color: ${({ theme  })=>rgba(theme.colors.white.base, 0.87)};
		content: '';
		height: 100%;
		position: absolute;
		right: -10%;
		top: 0;
		transform: skewX(-13deg);
		width: 112%;
	}
`;
export const BannerText = styled.p.withConfig({
    displayName: "styled__BannerText",
    componentId: "sc-6e364f97-3"
})`
	${FontMixin({
    weight: 'medium'
})}
	color: ${({ theme  })=>theme.colors.primary.base};
	position: relative;
`;
export const BannerButton = styled.span.withConfig({
    displayName: "styled__BannerButton",
    componentId: "sc-6e364f97-4"
})`
	${FontMixin({
    size: 'medium',
    weight: 'medium'
})}
	background-color: transparent;
	border-radius: ${BorderRadius({
    all: '3px'
})};
	border: 1px solid ${({ theme  })=>theme.colors.primary.base};
	color: ${({ theme  })=>theme.colors.primary.base};
	padding: 8px 16px;
	position: relative;
	text-transform: uppercase;

	&:hover {
		background-color: ${({ theme  })=>theme.colors.primary.base};
		color: ${({ theme  })=>theme.colors.white.base};
		text-decoration: none;
	}
`;
export const SkeletonWrapper = styled(Skeleton).withConfig({
    displayName: "styled__SkeletonWrapper",
    componentId: "sc-6e364f97-5"
})`
	margin: 16px;
`;

//# sourceMappingURL=styled.js.map